import { render, staticRenderFns } from "./LicenseRoot.vue?vue&type=template&id=ce0b043e"
import script from "./LicenseRoot.vue?vue&type=script&lang=ts"
export * from "./LicenseRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports